import * as React from "react";
const SvgFiRrSkiJump = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ski-jump_svg__a)">
      <path
        fill="#062147"
        d="M23.758 12.266a3.98 3.98 0 0 1-2.067 2.257L1.418 23.908a1 1 0 1 1-.84-1.816l4.43-2.05C5.005 20.027 5 20.015 5 20v-6.734a5.96 5.96 0 0 1 1.756-4.242L9.78 6H2a1 1 0 1 1 0-2h8.508c.937.001 1.845.33 2.566.931l.947.792a3 3 0 0 1 .1 4.338l-3.427 3.427a1 1 0 0 1-1.414-1.414l3.428-3.428a1 1 0 0 0-.018-1.43l-.707-.59-3.813 3.812A3.97 3.97 0 0 0 7 13.266v5.854l13.85-6.41a2 2 0 0 0 .962-2.657 1 1 0 1 1 1.813-.846 3.97 3.97 0 0 1 .133 3.06M16.5 4.982a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ski-jump_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkiJump;
